/* eslint-disable import/no-anonymous-default-export */
/**
 * 광고 캠페인 관리 설정
 */
import RefundBadge from "../components/RefundBadge";
export default {
  id: "adManagement",
  title: "광고 신청",

  api: {
    list: {
      method: "GET",
      url: "/advertisement/admin/campaigns",
    },
    count: {
      method: "GET",
      url: "/advertisement/admin/campaigns/count",
    },
    submitted: {
      method: "POST",
      url: "/advertisement/admin/campaigns/submitted",
    },
    paid: {
      method: "POST",
      url: "/advertisement/admin/campaigns/paid",
    },
    refund: {
      method: "POST",
      url: "/advertisement/admin/campaigns/refund",
      version: 2,
    },
    terminate: {
      method: "POST",
      url: "/advertisement/admin/campaigns/terminate",
    },
    delete: {
      method: "DELETE",
      url: "/advertisement/admin/campaigns",
    },
    keyword: {
      method: "POST",
      url: "/advertisement/admin/keyword",
    },
    date: {
      method: "PUT",
      url: "/advertisement/admin/campaign/date",
    },
  },

  filters: {
    default: {
      status: "전체",
      startDate: "",
      keyword: "",
      page: 1,
      limit: 50,
      submitted: "전체",
      paid: "전체",
      advertisers: [],
    },
    schema: [
      {
        name: "advertisers",
        label: "시행사",
        type: "checkbox-group",
        options: [
          { value: "버즈빌", label: "버즈빌" },
          { value: "호올스", label: "호올스" },
          { value: "토스", label: "토스" },
          { value: "베이직", label: "베이직" },
          { value: "길찾기", label: "길찾기" },
          { value: "당근", label: "당근" },
          { value: "멘토스", label: "멘토스" },
          { value: "브라보", label: "브라보" },
          { value: "찰리", label: "찰리" },
          { value: "제주", label: "제주" },
          { value: "투플", label: "투플" },
          { value: "기프트", label: "기프트" },
          { value: "최적화", label: "최적화" },
          { value: "핫팩", label: "핫팩" },
          { value: "카카오", label: "카카오" },
          { value: "강남", label: "강남" },
          { value: "일키 트래픽", label: "일키 트래픽" },
          { value: "썬데이", label: "썬데이" },
          { value: "백링크", label: "백링크" },
          { value: "N4", label: "N4" },
          { value: "화이트", label: "화이트" },
        ],
      },
      {
        name: "keyword",
        label: "검색",
        type: "text",
        placeholder: "플레이스명, 카테고리, 신청자",
      },
      {
        name: "startDate",
        label: "시작일",
        type: "date",
      },
      {
        name: "submitted",
        label: "접수여부",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "complete", label: "접수완료" },
          { value: "notComplete", label: "미접수" },
        ],
      },
      {
        name: "paid",
        label: "결제상태",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "complete", label: "결제완료" },
          { value: "notComplete", label: "미결제" },
          { value: "refund", label: "환불" },
        ],
      },
      {
        name: "status",
        label: "상태",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "waiting", label: "대기중" },
          { value: "active", label: "활성화" },
          { value: "expiringSoon", label: "종료임박" },
          { value: "terminated", label: "종료" },
        ],
      },
    ],
  },

  summary: {
    fields: [
      { key: "totalCount", label: "총 신청" },
      { key: "waitingCount", label: "대기중" },
      { key: "activeCount", label: "활성화" },
      { key: "expiringSoonCount", label: "종료임박" },
      { key: "terminatedCount", label: "종료" },
    ],
  },

  table: {
    keyField: "adCampaignMetaId",
    rowClick: {
      enabled: true,
      handler: (row) => {
        // 행 클릭 시 키워드 수정 모달 열기 (페이지 컴포넌트에서 처리)
      },
    },
    columns: [
      {
        key: "adCampaignMetaId",
        label: "아이디",
        center: true,
      },
      {
        key: "createdAt",
        label: "캐랭접수시간",
        center: true,
        render: (row) => {
          if (!row.createdAt) return "";
          const [date, time] = row.createdAt.split(" ");
          return (
            <>
              <div>{date}</div>
              <div>{time?.slice(0, 8)}</div>
            </>
          );
        },
      },
      {
        key: "userName",
        label: "접수자(ID)\n접수일\n상태",
        center: true,
        render: (row) => (
          <>
            <div>
              <span className="user-name">
                {row.userName}
                {row.userId ? ` (${row.userId})` : ""}
              </span>
            </div>
            <div>{row.submitDate || <>&nbsp;</>}</div>
            <div>
              <span className={`badge badge-${row.status}`}>{row.status}</span>
            </div>
          </>
        ),
      },
      {
        key: "startDate",
        label: "시작일\n종료일\n작업일수",
        center: true,
        render: (row) => (
          <>
            <div>
              <span
                className="date-blue"
                data-campaign-meta-id={row.adCampaignMetaId}
                data-start-date={row.startDate}
                data-end-date={row.endDate}
                style={{ cursor: "pointer" }}
              >
                {row.startDate}
              </span>
            </div>
            <div>
              <span className="date-red">{row.endDate}</span>
            </div>
            <div>{row.executionDays}일</div>
          </>
        ),
      },
      {
        key: "totalInflow",
        label: "총수량\n일수량\n총금액(단가)",
        center: true,
        render: (row) => (
          <>
            <div>{row.totalInflow?.toLocaleString()}건</div>
            <div>{row.dailyInflow?.toLocaleString()}건</div>
            <div>
              {row.totalCost?.toLocaleString()}원 (
              {row.adPrice?.toLocaleString()}원)
            </div>
          </>
        ),
      },
      {
        key: "advertiserName",
        label: "시행사\n플레이스명\nMID",
        center: true,
        render: (row) => (
          <>
            <div>
              {row.advertiserName}
            </div>
            <div>{row.placeName}</div>
            <div>{row.placeId || row.campaigns?.[0]?.url}</div>
          </>
        ),
      },
      {
        key: "keywords",
        label: "키워드 1~5",
        center: true,
        render: (row) => {
          const allKeywords = row.campaigns?.flatMap((c) => c.keywords) || [];
          return (
            <>
              {allKeywords.map((k, i) => (
                <div key={k.adKeywordId || i}>
                  <span
                    data-keyword={k.adKeyword}
                    style={{ cursor: "pointer" }}
                  >
                    {k.adKeyword}
                  </span>
                </div>
              ))}
            </>
          );
        },
      },
      {
        key: "rank",
        label: "순위/타입",
        center: true,
        render: (row) => {
          const allKeywords = row.campaigns?.flatMap((c) => c.keywords) || [];
          return (
            <>
              {allKeywords.map((k, i) => (
                <div key={k.adKeywordId || i}>
                  {k.rank}위 / {k.adType}
                </div>
              ))}
            </>
          );
        },
      },
      {
        key: "paymentType",
        label: "결제방법\n결제상태",
        center: true,
        render: (row) => (
          <>
            <div>
              {row.paymentType === "card"
                ? "카드"
                : row.paymentType === "v_bank"
                  ? "가상계좌"
                  : row.paymentType === "point"
                    ? "포인트 결제"
                    : "계좌이체"}
            </div>
            <div>
              {row.paid === "refund" ? (
                <RefundBadge
                  refundedAmount={row.refundedAmount ?? 0}
                  remainingAmount={row.remainingAmount ?? 0}
                  refundDate={row.refundDate}
                />
              ) : (
                <span
                  className={`badge badge-${row.paid === "complete" ? "결제완료" : "미결제"}`}
                >
                  {row.paid === "complete" ? "결제완료" : "미결제"}
                </span>
              )}
            </div>
          </>
        ),
      },
      {
        key: "notification",
        label: "알림톡",
        center: true,
        render: (row) => {
          const productName =
            row.productName ||
            row.offerName ||
            row.adName ||
            row.adProductName ||
            row.title ||
            row.campaigns?.[0]?.productName ||
            row.campaigns?.[0]?.offerName ||
            row.campaigns?.[0]?.adName ||
            "광고 캠페인";

          return (
            <button
              type="button"
              className="notification-btn"
              data-campaign-meta-id={row.adCampaignMetaId}
              data-action="notification"
              data-user-id={row.userId}
              data-product-name={productName}
              data-submitted-at={row.createdAt || row.submitDate || ""}
              data-purchase-amount={row.totalCost ?? ""}
              onClick={(e) => e.stopPropagation()}
            >
              알림톡
            </button>
          );
        },
      },
      {
        key: "memo",
        label: "메모",
        center: true,
        render: (row) => (
          <button
            type="button"
            className={row.memo ? "memo-btn has-memo" : "memo-btn"}
            data-action="memo"
            data-campaign-meta-id={row.adCampaignMetaId}
            data-memo={row.memo || ""}
            onClick={(e) => e.stopPropagation()}
          >
            {row.memo ? (
              <span className="memo-preview">{row.memo}</span>
            ) : (
              "메모"
            )}
          </button>
        ),
      },
    ],
  },

  actions: [
    {
      id: "submitted",
      label: "접수/취소",
      actionType: "submitted",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      payloadBuilder: (selectedIds, items) => {
        const hasUnsubmitted = items.some(
          (item) =>
            selectedIds.includes(item.adCampaignMetaId) &&
            item.submitted === "notComplete",
        );
        return {
          adCampaignMetaIds: selectedIds,
          toggleValue: hasUnsubmitted ? 1 : 0,
        };
      },
    },
    {
      id: "paid",
      label: "결제완료",
      actionType: "paid",
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        const alreadyPaid = items.some(
          (item) =>
            selectedIds.includes(item.adCampaignMetaId) &&
            item.paid === "complete",
        );
        return !alreadyPaid;
      },
      payloadBuilder: (selectedIds, items) => {
        const selectedCampaigns = items.filter((ad) =>
          selectedIds.includes(ad.adCampaignMetaId),
        );
        const uniqueTransactionIds = [
          ...new Set(
            selectedCampaigns
              .map((ad) => ad.adPaymentTransactionId)
              .filter((id) => id !== null && id !== undefined),
          ),
        ];

        return {
          adPaymentTransactionIds: uniqueTransactionIds,
          toggleValue: 1,
        };
      },
    },
    {
      id: "refund",
      label: "환불",
      actionType: "refund",
      requires: "ad.campaign.refund", // 권한 없으면 버튼 숨김 (R-FE-04)
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        return items.some(
          (item) =>
            selectedIds.includes(item.adCampaignMetaId) &&
            (item.paid === "complete" ||
              (item.paid === "refund" && (item.remainingAmount ?? 0) > 0)),
        );
      },
    },
    {
      id: "terminate",
      label: "종료/취소",
      actionType: "terminate",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      payloadBuilder: (selectedIds, items) => {
        const hasNotTerminated = items.some(
          (item) =>
            selectedIds.includes(item.adCampaignMetaId) &&
            item.status !== "종료",
        );
        return {
          adCampaignMetaIds: selectedIds.join(","),
          toggleValue: hasNotTerminated ? 1 : 0,
        };
      },
    },
    {
      id: "delete",
      label: "삭제",
      actionType: "delete",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      confirm: "선택한 캠페인을 삭제하시겠습니까?",
      payloadBuilder: (selectedIds, items) => {
        console.log("===items", items);
        const selectedCampaigns = items.filter((campaign) =>
          selectedIds.includes(campaign.adCampaignMetaId),
        );
        const campaigns = selectedCampaigns.map((campaign) => ({
          adCampaignMetaId: campaign.adCampaignMetaId,
          userName: campaign.userName,
        }));
        return {
          campaigns,
        };
      },
    },
  ],

  download: {
    type: "xlsx",
    multiSheet: true,
    fileName: "exported_campaigns.xlsx",
    // 다중 시트는 페이지 컴포넌트에서 직접 처리
    customHandler: true,
  },
};
